exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css"), undefined);

// module
exports.push([module.id, ".tableCell__cell__3o-Gs{display:block;width:100%}.tableCell__cell__3o-Gs,.tableCell__value__2nK5Q{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tableCell__value__2nK5Q{display:inline-block;max-width:100%}.tableCell__btn__qPcbw{background:none;border:none;color:#0075c9;cursor:pointer;font-size:1.4em;font-weight:700;display:inline-block;vertical-align:top;margin:5px -2px 0 0;padding:0 5px}.tableCell__btn__qPcbw:hover{color:#0064ab}", ""]);

// exports
exports.locals = {
	"blueDark": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["blueDark"] + "",
	"blue": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/colors.css").locals["blue"] + "",
	"cell": "tableCell__cell__3o-Gs",
	"value": "tableCell__value__2nK5Q",
	"btn": "tableCell__btn__qPcbw"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/tableCell/tableCell.css
// module id = 745
// module chunks = 0